import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { toGlobalId } from 'graphql-relay';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ChangeProfilePage from './change-profile';
import UpdateHEAccountMutation from '../../mutations/HEAccount/updateHEAccount';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query changeProfilePage($id: ID!) {
    viewer {
      id
      enabledFeatures
      uuid
    }
    node(id: $id) {
      id
      ... on HEAccount {
        id
        primaryUser {
          id
          firstName
          lastName
          email
          active
          role
          lockStatus
        }
        userList {
          id
          firstName
          lastName
          email
          active
          role
          lockStatus
        }
      }
    }
  }
`;

const graphqlData = graphql(query,
  {
    options: ({ current }) => ({
      variables: {
        id: toGlobalId('HEAccount', current.viewer.idToken['custom:institution']),
      },
      fetchPolicy: 'network-only',
    }),
  });
const updateHEAccount = graphql(UpdateHEAccountMutation, {
  name: 'mutateHEAccount',
});
const mapStateToProps = (state) => ({
  current: state.current,
});

export default compose(
  connect(mapStateToProps),
  SimpleLoadingComponent(graphqlData, updateHEAccount),
)(ChangeProfilePage);
